<div class="row fondoColor" [class.criticReview]="isCriticReview" (click)="onClick()">
    <div class="label-movie bg-warning" *ngIf="isCriticReview">Crítico</div>
    <div class="col-12 ">
        <div class="w-100 mb-3">
            <div class="row py-3 px-4">

                <div class="col pl-lg-0 tituloMasInfo">
                    <div class="row">
                        <div class="col-sm-12 col-md-9 col-lg-9">
                            <div class="author">
                                Comentado por:
                                <a [href]="authorProfileLink" class="authorHref">
                                    {{comment.author.firstName}} {{comment.author.lastName}}
                                </a>
                            </div>
                        </div>
                        <div class="col-3 d-none d-md-inline">
                            <div class="fechaText">
                                {{commentDateFormated}}
                            </div>
                        </div>
                    </div>

                    <!-- RATING -->
                    <div class="ratings" *ngIf="this.comment.score > 0">
                        <div class="row pl-3 pb-4">
                            <div *ngFor="let item of starsFull">
                                <i class="fas fa-star cm-tx-color-11"></i>
                            </div>
                            <div *ngFor="let item of starsHalf">
                                <i class="fas fa-star-half-alt cm-tx-color-11"></i>
                            </div>
                            <div *ngFor="let item of starsEmpty">
                                <i class="far fa-star cm-tx-color-11"></i>
                            </div>
                        </div>
                    </div>

                    <div class="commentContainter" *ngIf="comment.comment.length < maxCommentLenght">
                        <p class="comentario" [innerHTML]="comment.comment">
                        </p>
                    </div>

                    <div class="textButtons" *ngIf="comment.comment.length > maxCommentLenght">
                        <div *ngIf="!showMoreText" class="comentario">
                            <p class="elipsis-2" [innerHTML]="comment.comment">
                            </p>
                            <div class="col-12 px-0 buttonContain">
                                <a (click)="showMoreText = !showMoreText" class="showMore"> Ver más</a>
                            </div>
                        </div>
                        <div *ngIf="showMoreText" class="comentario">
                            <p [innerHTML]="comment.comment">
                            </p>
                            <div class="col-12 px-0 buttonContain">
                                <a (click)="showMoreText = !showMoreText" class="showMore"> Ver menos</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 d-md-none">
                        <div class="fechaText">
                            {{commentDateFormated}}
                        </div>
                    </div>

                </div>
                <br>
            </div>
        </div>
    </div>
</div>